var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMaleAvatar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 26,
    viewBox: "0 0 28 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_908_32064)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.8047,
    height: 25.7895,
    rx: 5.89474,
    fill: "#F8F9FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9033 19.2554C7.99269 19.2554 3.04576 23.3812 1.78535 28.91C1.44207 30.4158 2.72662 31.684 4.27106 31.684H23.5355C25.0799 31.684 26.3645 30.4158 26.0212 28.91C24.7608 23.3812 19.8138 19.2554 13.9033 19.2554Z",
    fill: "#8FCAE6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9033 6.36035C16.5157 6.36038 18.7196 8.74484 18.7197 11.7979C18.7197 14.851 16.5158 17.2353 13.9033 17.2354C11.2909 17.2354 9.08691 14.851 9.08691 11.7979C9.08706 8.74482 11.2909 6.36035 13.9033 6.36035Z",
    fill: "white",
    stroke: "#3C4657",
    strokeWidth: 0.93215
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_908_32064"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.8047,
    height: 25.7895,
    rx: 5.89474,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaleAvatar);
export default __webpack_public_path__ + "static/media/MaleAvatar.3803f7e6a7d0d3474a6706a1348db150.svg";
export { ForwardRef as ReactComponent };